import _api from "./api";
import _endpoints from "./endpoints";

export default {
    async getMyStorageContractBoxes() {
        const {data} = await _api.get(_endpoints.my_storage_contract_boxes);

        return data.list ? data.list : null;
    },
    async getBoxContent(usboxId) {
        const {data} = await _api.get(_endpoints.storage_contract_box_id.replace(':usbox_id', usboxId));

        return data || null;
    },
    async getBoxContentBySerial(serial) {
        const {data} = await _api.get(_endpoints.storage_contract_box_content_by_serial.replace(':serial', serial));

        return data || null;
    },
    async getBoxSimpleContentBySerial(serial) {
        const {data} = await _api.get(_endpoints.storage_contract_box_simple_content_by_serial.replace(':serial', serial));

        return data || null;
    },
    async getBoxContentIsRegisteredBySerial(serial) {
        const {data} = await _api.get(_endpoints.storage_contract_box_content_registered_by_serial.replace(':serial', serial));

        return data || null;
    },
    async updateBoxContent(boxId, boxContent) {
        const {data} = await _api.put(_endpoints.storage_contract_box_id.replace(':usbox_id', boxId), boxContent);

        return data || null;
    },

    async getBoxListByDeliverySerial(serial) {
        const {data} = await _api.get(_endpoints.delivery_boxes_by_serial.replace(':serial', serial));

        return data || null;
    },

    async extensionContract(type, id) {
        await _api.post(_endpoints.contract_extension.replace(':id', id).replace(':type', type));
    },

    /**
     * 선택 약정 해지에 대한 수수료 계산.
     * @param spcId
     * @param boxCnt
     * @returns {Promise<void>}
     */
    async getAmountTermination(spcId, boxCnt) {
        const { data } = await _api.post(_endpoints.get_contract_termination_price.replace(':id', spcId), {
            cnt: boxCnt
        });
        return data || null;
    },

    /**
     * 선택 약정 해지처리.
     * @param spcId
     * @param boxes
     * @returns {Promise<void>}
     */
    async terminationContract(spcId, boxes) {
        const { data } = await _api.post(_endpoints.contract_termination.replace(':id', spcId), {
            boxes: boxes
        });
        return data || null;
    },

    /**
     * 선택 약정 업그레이드처리.
     * @param spcId
     * @param boxes
     * @returns {Promise<void>}
     */
    async upgradeContract(spcId, type, boxes) {
        const { data } = await _api.put(_endpoints.contract_upgrade.replace(':id', spcId).replace(':type', type), {
            boxes: boxes
        });
        return data || null;
    },

    /**
     * 약정 기초금액 데이터 로그.
     * @returns {Promise<any|null>}
     */
    async getContractPrice() {
        const { data } = await _api.get(_endpoints.get_contract_price);
        return data || null;
    },
    /**
     * 주문 견적 금액로드.
     * @param type
     * @param order
     * @returns {Promise<any|null>}
     */
    async getOrderPrice(type, order) {
        const { data } = await _api.post(_endpoints.get_storage_order_price.replace(':type', type), order);
        return data || null;
    },
    /**
     * 중간배송 금액 조회
     * @param type
     * @param delivery
     * @returns {Promise<any|null>}
     */
    async getDeliveryPrice(delivery) {
        const { data } = await _api.post(_endpoints.get_storage_delivery_amount, delivery);
        return data || null;
    },
    /**
     * 보관종료 - 배송 금액 조회
     * @param id
     * @param delivery
     * @returns {Promise<any|null>}
     */
    async getFinishDeliveryPrice(id, delivery) {
        const { data } = await _api.post(_endpoints.get_storage_finish_delivery_amount.replace(':id', id), delivery);
        return data || null;
    },
    /**
     * 보관종료 - 폐기 금액 조회
     * @param id
     * @param delivery
     * @returns {Promise<any|null>}
     */
    async getFinishDisposePrice(id, boxes) {
        const { data } = await _api.post(_endpoints.get_storage_finish_dispose_amount.replace(':id', id), boxes);
        return data || null;
    },
    /**
     * 중간배송 신청.
     * @param type
     * @param delivery
     * @returns {Promise<any|null>}
     */
    async requestDelivery(delivery) {
        const { data } = await _api.post(_endpoints.storage_delivery, delivery);
        return data || null;
    },
    /**
     * 중간배송 일반 결제 완료.
     * @param serial
     * @param obj
     * @returns {Promise<any|null>}
     */
    async paymentCompleteDelivery(serial, obj) {
        const { data } = await _api.post(_endpoints.storage_delivery_paid_by_serial.replace(':serial', serial), obj);
        return data || null;
    },
    /**
     * 배송 삭제
     * @param serial
     * @returns {Promise<AxiosResponse<any>>}
     */
    async deleteDelivery(serial) {
        return await _api.delete(_endpoints.storage_delivery_serial.replace(':serial', serial));
    },
    /**
     * 폐기신청 삭제
     * @param serial
     * @returns {Promise<AxiosResponse<any>>}
     */
    async deleteDispose(serial) {
        return await _api.delete(_endpoints.storage_delivery_serial.replace(':serial', serial));
    },
    /**
     * 보관종료 - 배송 신청.
     * @param delivery
     * @returns {Promise<any|null>}
     */
    async requestFinishDelivery(delivery) {
        const { data } = await _api.post(_endpoints.storage_finish_delivery, delivery);
        return data || null;
    },
    /**
     * 보관종료 - 폐기 신청.
     * @param delivery
     * @returns {Promise<any|null>}
     */
    async requestFinishDispose(obj) {
        const { data } = await _api.post(_endpoints.storage_finish_dispose.replace(':serial', obj.serial), obj);
        return data || null;
    },

    async getStorageEstimateAmountInitial(contract) {
        const { data } = await _api.post(_endpoints.get_estimate_storage_amount_initial, contract);
        return data || null;
    },
    async getStorageEstimateAmountWithMove(contract) {
        const { data } = await _api.post(_endpoints.get_estimate_storage_amount_with_move, contract);
        return data || null;
    },
    async getStorageEstimateAmountExtension(contract) {
        const { data } = await _api.post(_endpoints.get_estimate_storage_amount_extension, contract);
        return data || null;
    },

    async getStorageEstimateAmountDelivery(contract) {
        const { data } = await _api.post(_endpoints.get_estimate_storage_amount_delivery, contract);
        return data || null;
    },

    async getStorageEstimateAmountFinalDelivery(contract) {
        const { data } = await _api.post(_endpoints.get_estimate_storage_amount_final, contract);
        return data || null;
    },

    async getStorageEstimateAmountFinalDispose(contract) {
        const { data } = await _api.post(_endpoints.get_estimate_storage_amount_dispose, contract);
        return data || null;
    },

    async getStorageEstimateAmountSimple(contract) {
        const { data } = await _api.post(_endpoints.get_estimate_storage_amount_simple, contract);
        return data || null;
    },

    async addContract(contract) {
        if (contract.address_passwd === false) contract.address_passwd = null;
        if (!contract.us_cp_id) contract.us_cp_id = null;

        const { data } = await _api.post(_endpoints.add_storage_contracts, contract);
        return data || null;
    },

    async addContractV2ForEvent(contract) {
        if (contract.address_passwd === false) contract.address_passwd = null;
        if (!contract.us_cp_id) contract.us_cp_id = null;

        const { data } = await _api.post(_endpoints.add_storage_contracts_v2_for_event3, contract);
        return data || null;
    },

    async addContractV2(contract) {
        if (contract.address_passwd === false) contract.address_passwd = null;
        if (!contract.us_cp_id) contract.us_cp_id = null;

        const { data } = await _api.post(_endpoints.add_storage_contracts_v2, contract);
        return data || null;
    },

    async getOrderBySerial(serial) {
        const { data } = await _api.get(_endpoints.storage_order_serial.replace(':serial', serial));
        return data || null;
    },

    async getContractsBySerial(serial) {
        const { data } = await _api.get(_endpoints.storage_contracts_by_serial.replace(':serial', serial));
        return data || null;
    },

    async getFinishedBoxesBySerial(serial) {
        const { data } = await _api.get(_endpoints.storage_finished_boxes_by_serial.replace(':serial', serial));
        return data || null;
    },

    async getPaymentsBySerial(serial) {
        const { data } = await _api.get(_endpoints.storage_payments_by_serial.replace(':serial', serial));
        return data || null;
    },

    async getAvailableDeliveryBoxesBySerial(serial) {
        const { data } = await _api.get(_endpoints.get_available_delivery_boxes_by_serial.replace(':serial', serial));
        return data || null;
    },

    async extensionBoxes(contract) {
        const { data } = await _api.post(_endpoints.extend_storage_boxes, contract);
        return data || null;
    },

    async deliveryBoxes(contract) {
        if (contract.address_passwd === false) contract.address_passwd = null;

        const { data } = await _api.post(_endpoints.delivery_storage_boxes, contract);
        return data || null;
    },
    async finalDeliveryBoxes(contract) {
        if (contract.address_passwd === false) contract.address_passwd = null;

        const { data } = await _api.post(_endpoints.final_storage_boxes, contract);
        return data || null;
    },
    async finalDisposeBoxes(contract) {
        const { data } = await _api.post(_endpoints.dispose_storage_boxes, contract);
        return data || null;
    },

    async paymentComplete(obj) {
        const { data } = await _api.post(_endpoints.storage_payment_complete, obj);
        return data || null;
    },

    async paymentCompleteV2(obj) {
        const { data } = await _api.post(_endpoints.storage_payment_complete_v2, obj);
        return data || null;
    },

    async cancelOrder(serial) {
        await _api.post(_endpoints.storage_contract_cancel_v2.replace(':serial', serial));
    },

    async cancelDelivery(serial) {
        await _api.post(_endpoints.storage_delivery_cancel.replace(':serial', serial));
    },

    async updatePaymentIdForOrder(serial, paymentId) {
        await _api.put(_endpoints.storage_order_serial_payment_id.replace(':serial', serial).replace(':id', paymentId));
    },

    async registerBoxContent(serial, content) {
        await _api.post(_endpoints.storage_contract_box_content_register.replace(':serial', serial), content);
    },

    async registerBoxImage(serial, file) {
        const {data} = await _api.post(_endpoints.storage_contract_box_content_register_img.replace(':serial', serial),
            file,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );

        return data ? data : null;
    },
    //
    // async updateBoxContentBySerial(serial, content) {
    //     await _api.put(_endpoints.storage_contract_box_content_by_serial.replace(':serial', serial), content);
    // },

    async deleteEstimate(serial) {
        await _api.delete(_endpoints.get_storage_contract_by_serial.replace(':serial', serial));
    },

    async deleteEstimateV2(serial) {
        await _api.delete(_endpoints.get_storage_contract_by_serial_v2.replace(':serial', serial));
    },

    async loadMyOrders() {
        let {data} = await _api.get(_endpoints.get_my_storage_orders);
        return data || null;
    }
}
